import { ClientError, GraphQLClient } from 'graphql-request';
import { env } from 'lib/constants/env';

const url = `https://${env.NEXT_PUBLIC_SHOPIFY_HOST}/api/${env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION}/graphql.json`;
const customerUrl = `https://shopify.com/${env.NEXT_PUBLIC_SHOPIFY_SHOP_ID}/account/customer/api/${env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION}/graphql`;

export const shopifyStorefrontGraphQLClient = new GraphQLClient(url, {
  headers: {
    'X-Shopify-Storefront-Access-Token':
      env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN || '',
  },
});

export const shopifyCustomerGraphQLClient = new GraphQLClient(customerUrl);

export const parseGraphQLError = (error: unknown): string => {
  if (error instanceof ClientError) {
    return error.response.errors?.[0]?.message || error.message;
  }

  return error instanceof Error ? error.message : String(error);
};
